import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { rethrowDffError } from "@dffedb/rxjs";
import { InstallationHttpClient, ParametreForAktuelleInstallation } from "@e-forsyning/common/http";

import { InstallationMaalerAflaesningMapper } from "./installation-maaler-aflaesning.mapper";
import { InstallationMaalerAflaesningDto } from "./model/installation-maaler-aflaesning.dto";
import { InstallationMaalerAflaesning } from "./model/installation-maaler-aflaesning.model";

@Injectable({ providedIn: "root" })
export class InstallationMaalerAflaesningRepository {
    constructor(private readonly http: InstallationHttpClient, private readonly mapper: InstallationMaalerAflaesningMapper) {}

    public hentMaalerAflaesningForAktuelleInstallation(): Observable<InstallationMaalerAflaesning> {
        return this.http.get("api/GetAflaesOpl", ParametreForAktuelleInstallation.true).pipe(
            map((data) => data.aflaesoplysninger[0] as InstallationMaalerAflaesningDto),
            map((data) => this.mapper.dtoToInstallationMaalerAflaesning(data)),
            rethrowDffError()
        );
    }

    public gemMaalerAflaesning(maalerAflaesning: InstallationMaalerAflaesning): Promise<void> {
        const data = {
            aflaesoplysninger: [this.mapper.installationMaalerAflaesningToDto(maalerAflaesning)]
        };
        return this.http.post("api/GemAflaesning", data, ParametreForAktuelleInstallation.true).toPromise();
    }
}
